import axios from "axios";
import {
  calculateOrderPrice,
  capture_PCI,
  fetchLocationAPI,
  filterMobiileAPI,
  healthCheckEndpoint,
  optimumPlanDropdown,
  saveOrderAPI,
  send_otp,
  validate_otp,
  verifTokenAPI,
  verifyEmailTokenAPI,
  verifyPCITokenAPI,
} from "./apiEndPoints";
import axiosInterceptor from "../utils/axiosInterceptors";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

//Optimum Plan Dropdown
export async function fetchOptimumDropdown() {
  const requestData = await axiosInterceptor
    .get(optimumPlanDropdown)
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

//Submit Order Details
export async function saveOrderDetails(data) {
  const requestData = await axiosInterceptor
    .post(saveOrderAPI, data)
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

//Email Token Verification
export async function verifyToken(tokenparam, orderparam) {
  const requestData = await axios
    .get(`${baseUrl}${verifTokenAPI(tokenparam, orderparam)}`)
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

//submit PCI vault token
export async function verifyPCIToken(token, orderId, uniqueid) {
  const requestData = await axios
    .patch(`${baseUrl}${verifyPCITokenAPI(orderId)}`, {
      cc_token: token,
      uniqueid: uniqueid,
    })
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

//fetch location
export async function fetchLocation(zipcode) {
  const requestData = await axiosInterceptor
    .get(`${fetchLocationAPI(zipcode)}`)
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

//calculate order price
export async function fetchOrderPrice(details) {
  const requestData = await axiosInterceptor
    .post(calculateOrderPrice, details)
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

//filtering of mobile device
export async function fetchFilteredMobile(details) {
  const requestData = await axiosInterceptor
    .get(filterMobiileAPI(details))
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

//send-otp
export async function sendOtp(orderId) {
  const requestData = await axios
    .get(`${baseUrl}${send_otp(orderId)}`)
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

//validate-otp
export async function validateOtp(orderId, otp) {
  const requestData = await axios
    .post(`${baseUrl}${validate_otp(orderId)}`, {
      otp: otp,
    })
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

//capture-pci
export async function capturePci(token, orderId) {
  const requestData = await axios
    .get(`${baseUrl}${capture_PCI(orderId)}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((resp) => {
      return resp.data;
    })
    .catch((error) => {
      return error;
    });
  return requestData;
}

export const healthCheck = async () => {
  try {
    const response = await axiosInterceptor.get(healthCheckEndpoint);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Heath Check failed");
  }
};